import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { DataService } from '../data.service';

import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
  	italics: 'Roboto-Italic.ttf',
  	bolditalics: 'Roboto-MediumItalic.ttf' 
	},
  Cour: {
    normal: 'CourierPrime-Regular.ttf',
    bold: 'CourierPrime-Bold.ttf',
    italics: 'CourierPrime-Italic.ttf',
    bolditalics: 'CourierPrime-BoldItalic.ttf'
  }
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-ingresos',
  templateUrl: './ingresos.component.html',
  styleUrls: ['./ingresos.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})

export class IngresosComponent implements OnInit {
  errMsg:string = "";
  okMsg:string = "";
  tiempoMsg:number = 3100;
  loading:boolean=false;
  item:any=[];
  forms:any=[];
  origenes:any=[];
  ticket:any=[];
  idOrigen:number = -1;
  numConceptos=1;
  
  idForm1:number = -1;
  idForm2:number = -1;
  idForm3:number = -1;
  idForm4:number = -1;
  idForm5:number = -1;
  idForm6:number = -1;
  idForm7:number = -1;
  idForm8:number = -1;
  idForm9:number = -1;
  idForm10:number = -1;
  
  qty1:number = 1;
  qty2:number = 1;
  qty3:number = 1;
  qty4:number = 1;
  qty5:number = 1;
  qty6:number = 1;
  qty7:number = 1;
  qty8:number = 1;
  qty9:number = 1;
  qty10:number = 1;
  
  total:number = 0;
  
  fecEmi:string="";
  horaEmi:string="";
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  dd:any;
  consolidaImp:boolean=false;
  result:any;
  corte:string="";
  abrirDescargarPDF:number=-1;
  esFechaEspecial:boolean=false;
  fechaEspecial:any=[];
  recibo:any;

  thisForm = new FormGroup({
    origen: new FormControl(this.item.origen, [Validators.required]),
    qty1: new FormControl(this.item.qty1, [Validators.required]),
    prod1: new FormControl(this.item.prod1, [Validators.required]),
    form1: new FormControl(this.item.form1, [Validators.required]),
    importe1: new FormControl(this.item.importe1, [Validators.required]),
    ref1: new FormControl(this.item.ref1, []),
    qty2: new FormControl(this.item.qty2, [Validators.required]),
    prod2: new FormControl(this.item.prod2, [Validators.required]),
    form2: new FormControl(this.item.form2, [Validators.required]),
    importe2: new FormControl(this.item.importe2, [Validators.required]),
    ref2: new FormControl(this.item.ref2, []),
    qty3: new FormControl(this.item.qty3, [Validators.required]),
    prod3: new FormControl(this.item.prod3, [Validators.required]),
    form3: new FormControl(this.item.form3, [Validators.required]),
    importe3: new FormControl(this.item.importe3, [Validators.required]),
    ref3: new FormControl(this.item.ref3, []),
    qty4: new FormControl(this.item.qty4, [Validators.required]),
    prod4: new FormControl(this.item.prod4, [Validators.required]),
    form4: new FormControl(this.item.form4, [Validators.required]),
    importe4: new FormControl(this.item.importe4, [Validators.required]),
    ref4: new FormControl(this.item.ref4, []),
    qty5: new FormControl(this.item.qty5, [Validators.required]),
    prod5: new FormControl(this.item.prod5, [Validators.required]),
    form5: new FormControl(this.item.form5, [Validators.required]),
    importe5: new FormControl(this.item.importe5, [Validators.required]),
    ref5: new FormControl(this.item.ref5, []),
    qty6: new FormControl(this.item.qty6, [Validators.required]),
    prod6: new FormControl(this.item.prod6, [Validators.required]),
    form6: new FormControl(this.item.form6, [Validators.required]),
    importe6: new FormControl(this.item.importe6, [Validators.required]),
    ref6: new FormControl(this.item.ref6, []),
    qty7: new FormControl(this.item.qty7, [Validators.required]),
    prod7: new FormControl(this.item.prod7, [Validators.required]),
    form7: new FormControl(this.item.form7, [Validators.required]),
    importe7: new FormControl(this.item.importe7, [Validators.required]),
    ref7: new FormControl(this.item.ref7, []),
    qty8: new FormControl(this.item.qty8, [Validators.required]),
    prod8: new FormControl(this.item.prod8, [Validators.required]),
    form8: new FormControl(this.item.form8, [Validators.required]),
    importe8: new FormControl(this.item.importe8, [Validators.required]),
    ref8: new FormControl(this.item.ref8, []),
    qty9: new FormControl(this.item.qty9, [Validators.required]),
    prod9: new FormControl(this.item.prod9, [Validators.required]),
    form9: new FormControl(this.item.form9, [Validators.required]),
    importe9: new FormControl(this.item.importe9, [Validators.required]),
    ref9: new FormControl(this.item.ref9, []),
    qty10: new FormControl(this.item.qty10, [Validators.required]),
    prod10: new FormControl(this.item.prod10, [Validators.required]),
    form10: new FormControl(this.item.form10, [Validators.required]),
    importe10: new FormControl(this.item.importe10, [Validators.required]),
    ref10: new FormControl(this.item.ref10, []),
    chkConsolida: new FormControl(this.consolidaImp, []),
  });
  
  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.thisForm.controls["qty1"].setValue(1);
    this.idForm1 = 11;   //--> Efectivo = 11
    this.thisForm.controls["form1"].setValue(this.idForm1);
    this.dataService.getVars("PDF_O-D").subscribe(
                      rows => {   
                              this.abrirDescargarPDF = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnPDF_Abrir_Descargar_Obtenido());
    this.dataService.getVars("FEC-TIC").subscribe(
                      rows => {   
                              this.esFechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecialObtenida());
    this.dataService.getOrigenes('1').subscribe(
                      rows => {   
                              this.origenes = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnOrigenesCargados());

    this.dataService.getFormatoImp(1, 1).subscribe(
                      rows => {   
                              this.formato = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormatoImpCargado());

    this.dataService.getFormAct().subscribe(
                      rows => {   
                              this.forms = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFormasCargadas());

  }

  fnOrigenesCargados(){
    console.log(this.origenes);
  }

  fnPDF_Abrir_Descargar_Obtenido(){
    //console.log(this.abrirDescargarPDF);
  }

  fnFechaEspecialObtenida(){
    //console.log(this.esFechaEspecial);
    if(this.esFechaEspecial){
      this.dataService.getFechaEspecial().subscribe(
                      rows => {   
                              this.fechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecial());
    }
  }

  fnFechaEspecial(){
    //console.log(this.fechaEspecial);
    this.fechaEspecial = moment(this.fechaEspecial[0].fecha.substr(6,4) + "/" + this.fechaEspecial[0].fecha.substr(3,2) + "/" + this.fechaEspecial[0].fecha.substr(0,2)).format("DD/MM/YYYY");
    //console.log(this.fechaEspecial);
  }
  
  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }
  
  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  fnFormasCargadas(){
    //console.log(this.forms);    
  }

  fnKeyPress(t, e){
    this.errMsg="";
    //console.log("KeyPress")
    //console.log(e)
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg); 
        return false;   
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="ORIG"){
      this.idOrigen = idEl;
    }   
    if(tipo=="FORM1"){
      this.idForm1 = idEl;
    }   
    if(tipo=="FORM2"){
      this.idForm2 = idEl;
    }   
    if(tipo=="FORM3"){
      this.idForm3 = idEl;
    }   
    if(tipo=="FORM4"){
      this.idForm4 = idEl;
    }   
    if(tipo=="FORM5"){
      this.idForm5 = idEl;
    }   
    if(tipo=="FORM6"){
      this.idForm6 = idEl;
    }
    if(tipo=="FORM7"){
      this.idForm7 = idEl;
    }   
    if(tipo=="FORM8"){
      this.idForm8 = idEl;
    }   
    if(tipo=="FORM9"){
      this.idForm9 = idEl;
    }  
    if(tipo=="FORM10"){
      this.idForm10 = idEl;
    }  
  }


  fnCalculaTotal(){
    var auxTot = 0.0;
    if(this.thisForm.controls["importe1"].value)
      auxTot = parseFloat(this.thisForm.controls["importe1"].value);
    if(this.thisForm.controls["importe2"].value)
      auxTot += parseFloat(this.thisForm.controls["importe2"].value);
    if(this.thisForm.controls["importe3"].value)
      auxTot += parseFloat(this.thisForm.controls["importe3"].value);
    if(this.thisForm.controls["importe4"].value)
      auxTot += parseFloat(this.thisForm.controls["importe4"].value);
    if(this.thisForm.controls["importe5"].value)
      auxTot += parseFloat(this.thisForm.controls["importe5"].value);
    if(this.thisForm.controls["importe6"].value)
      auxTot += parseFloat(this.thisForm.controls["importe6"].value);
    if(this.thisForm.controls["importe7"].value)
      auxTot += parseFloat(this.thisForm.controls["importe7"].value);
    if(this.thisForm.controls["importe8"].value)
      auxTot += parseFloat(this.thisForm.controls["importe8"].value);
    if(this.thisForm.controls["importe9"].value)
      auxTot += parseFloat(this.thisForm.controls["importe9"].value);
    if(this.thisForm.controls["importe10"].value)
      auxTot += parseFloat(this.thisForm.controls["importe10"].value);
    this.total = auxTot;
  }

  fnAgregarConcepto(){
    //console.log(this.numConceptos);
    this.numConceptos++;
  }

  fnQuitarConcepto(){
    if(this.numConceptos==9){
      this.thisForm.controls["importe9"].reset();
      this.thisForm.controls["ref9"].reset();
      this.thisForm.controls["form9"].reset();
      this.idForm9 = -1
    }
    if(this.numConceptos==8){
      this.thisForm.controls["importe8"].reset();
      this.thisForm.controls["ref8"].reset();
      this.thisForm.controls["form8"].reset();
      this.idForm8 = -1
    }
    if(this.numConceptos==7){
      this.thisForm.controls["importe7"].reset();
      this.thisForm.controls["ref7"].reset();
      this.thisForm.controls["form7"].reset();
      this.idForm7 = -1
    }
    if(this.numConceptos==6){
      this.thisForm.controls["importe6"].reset();
      this.thisForm.controls["ref6"].reset();
      this.thisForm.controls["form6"].reset();
      this.idForm6 = -1
    }
    if(this.numConceptos==5){
      this.thisForm.controls["importe5"].reset();
      this.thisForm.controls["ref5"].reset();
      this.thisForm.controls["form5"].reset();
      this.idForm5 = -1
    }
    if(this.numConceptos==4){
      this.thisForm.controls["importe4"].reset();
      this.thisForm.controls["ref4"].reset();
      this.thisForm.controls["form4"].reset();
      this.idForm4 = -1
    }
    if(this.numConceptos==3){
      this.thisForm.controls["importe3"].reset();
      this.thisForm.controls["ref3"].reset();
      this.thisForm.controls["form3"].reset();
      this.idForm3 = -1
    }
    if(this.numConceptos==2){
      this.thisForm.controls["importe2"].reset();    
      this.thisForm.controls["ref2"].reset();
      this.thisForm.controls["form2"].reset();
      this.idForm2 = -1
    }
    this.numConceptos--;
    this.fnCalculaTotal();
  }

  fnGenerar(){
    //console.log(this.numConceptos);
    this.loading = true;
    this.fecEmi = this.dataService.fnGetDateFormat(this.dataService.fnGetHoy(), 'D/M/Y');
    if(this.esFechaEspecial){
      this.fecEmi = this.fechaEspecial;
    }
    this.horaEmi = this.dataService.fnGetAhora();

    var msg="";
    if(this.numConceptos > 6){
      if(this.thisForm.controls["importe7"].value == null || this.thisForm.controls["importe7"].value <= 0){
        msg = "Ingrese importe en el concepto 7";            
      }
      if(this.idForm7 < 0){
        msg = "Ingrese forma de pago en el concepto 7";            
      }
    }
    if(this.numConceptos > 5){
      if(this.thisForm.controls["importe6"].value == null || this.thisForm.controls["importe6"].value <= 0){
        msg = "Ingrese importe en el concepto 6";            
      }
      if(this.idForm6 < 0){
        msg = "Ingrese forma de pago en el concepto 6";            
      }
    }
    if(this.numConceptos > 4){
      if(this.thisForm.controls["importe5"].value == null || this.thisForm.controls["importe5"].value <= 0){
        msg = "Ingrese importe en el concepto 5";            
      }
      if(this.idForm5 < 0){
        msg = "Ingrese forma de pago en el concepto 5";            
      }
    }
    if(this.numConceptos > 3){
      if(this.thisForm.controls["importe4"].value == null || this.thisForm.controls["importe4"].value <= 0){
        msg = "Ingrese importe en el concepto 4";            
      }
      if(this.idForm4 < 0){
        msg = "Ingrese forma de pago en el concepto 4";            
      }
    }
    if(this.numConceptos > 2){
      if(this.thisForm.controls["importe3"].value == null || this.thisForm.controls["importe3"].value <= 0){
        msg = "Ingrese importe en el concepto 3";            
      }
      if(this.idForm3 < 0){
        msg = "Ingrese forma de pago en el concepto 3";            
      }
    }
    if(this.numConceptos > 1){
      if(this.thisForm.controls["importe2"].value == null || this.thisForm.controls["importe2"].value <= 0){
        msg = "Ingrese importe en el concepto 2";            
      }
      if(this.idForm2 < 0){
        msg = "Ingrese forma de pago en el concepto 2";            
      }
    }
    if(this.thisForm.controls["importe1"].value == null || this.thisForm.controls["importe1"].value <= 0){
      msg = "Ingrese importe en el concepto 1";            
    }
    if(this.idForm1 < 0){
      msg = "Ingrese forma de pago en el concepto 1";            
    }
    if(msg.length > 0){
      this.loading = false;
      this.errMsg = msg;
      setTimeout(() => {
        this.errMsg = "";
      }, this.tiempoMsg);
    }
    else{
      //console.log("GUARDAR!")
      var auxSub = [];
      var auxForm = [];
      var auxFormaStr = [];
      var auxRef = [];
      for(var i = 0; i < this.numConceptos; i++){
        if(i == 0){
          auxSub.push(this.thisForm.controls["importe1"].value);
          auxForm.push(this.idForm1);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm1, "id").forma);
          auxRef.push(this.thisForm.controls["ref1"].value);
        }
        if(i == 1){
          auxSub.push(this.thisForm.controls["importe2"].value);
          auxForm.push(this.idForm2);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm2, "id").forma);
          auxRef.push(this.thisForm.controls["ref2"].value);
        }
        if(i == 2){
          auxSub.push(this.thisForm.controls["importe3"].value);
          auxForm.push(this.idForm3);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm3, "id").forma);
          auxRef.push(this.thisForm.controls["ref3"].value);
        }
        if(i == 3){
          auxSub.push(this.thisForm.controls["importe4"].value);
          auxForm.push(this.idForm4);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm4, "id").forma);
          auxRef.push(this.thisForm.controls["ref4"].value);
        }
        if(i == 4){
          auxSub.push(this.thisForm.controls["importe5"].value);
          auxForm.push(this.idForm5);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm5, "id").forma);
          auxRef.push(this.thisForm.controls["ref5"].value);
        }
        if(i == 5){
          auxSub.push(this.thisForm.controls["importe6"].value);
          auxForm.push(this.idForm6);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm6, "id").forma);
          auxRef.push(this.thisForm.controls["ref6"].value);
        }
        if(i == 6){
          auxSub.push(this.thisForm.controls["importe7"].value);
          auxForm.push(this.idForm7);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm7, "id").forma);
          auxRef.push(this.thisForm.controls["ref7"].value);
        }
        if(i == 7){
          auxSub.push(this.thisForm.controls["importe8"].value);
          auxForm.push(this.idForm8);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm8, "id").forma);
          auxRef.push(this.thisForm.controls["ref8"].value);
        }
        if(i == 8){
          auxSub.push(this.thisForm.controls["importe9"].value);
          auxForm.push(this.idForm9);
          auxFormaStr.push(this.dataService.findItemInObject(this.forms, this.idForm9, "id").forma);
          auxRef.push(this.thisForm.controls["ref9"].value);
        }
      }
      this.dataService.insTicketIngreso(this.idOrigen, -1, this.numConceptos, auxSub.join(), 0, auxSub.join(), auxForm.join(), this.fecEmi, this.horaEmi, auxRef.join('|')).subscribe(
                    rows => {   
                            this.ticket = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnTicketsGuardados(auxSub, auxFormaStr, auxRef));

    }
  }

  fnReciboGenerado(){
    //console.log(this.recibo);
  }

  fnTicketsGuardados(arrSub:any, arrForm:any, arrRef:any){
    if(this.ticket.folios){
      var arrFolio = this.ticket.folios.split(",");      
      console.log("TICKET GUARDADO: " + arrFolio.join());
      this.dataService.fnWait(55);
      //--> INSERTAR FOLIO DE RECIBO DE INGRESOS
      this.dataService.insRecibo(0, "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1), arrFolio[0], arrFolio[arrFolio.length-1], this.fecEmi).subscribe(
                          row => { this.recibo = <any>row; }, 
                          error => this.errMsg = <any>error, 
                          () => this.fnReciboGenerado() );
    
      this.dataService.insLog(5,'TICKET-ING', this.numConceptos + "|" + this.idOrigen + "|" + this.total + "|" + this.fecEmi + "|" + this.horaEmi + "|" + arrSub.join(),'').subscribe(                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
      this.fnImprimirRecibo(arrFolio[0], arrFolio[arrFolio.length-1], arrForm.join(), arrSub.join(), arrRef.join('|'));  
      this.okMsg = "Ingresos almacenados correctamente.";
    }
    else{
      this.errMsg = "Ocurrió un error al almacenar los ingresos."
    }
    this.loading = false;
  }

  fnLimpia(){
    for(var i = this.numConceptos; i > 1; i--){
      this.fnQuitarConcepto();
    }
    this.thisForm.controls["form1"].reset();
    this.thisForm.controls["importe1"].reset();
    this.thisForm.controls["ref1"].reset();
    this.fnCalculaTotal();
    this.thisForm.controls["origen"].reset();
    setTimeout(() => {
      this.okMsg = "";
    }, 5000);
  }

  fnImprimirRecibo(folio:string, folioFin:string, arrForm:string, arrTotal:string, arrRef:string){
    this.dataService.insLog(5, 'IMPRIMIR', "RECIBO INGRESO", folio != folioFin ? folio + " al " + folioFin : folio).subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(9, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionReciboCargados(9, folio, folioFin, arrForm, arrTotal, arrRef));              
  }

  fnElementosImpresionReciboCargados(idFormato, folio, folioFin, arrForm, arrTotal, arrRef){    
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    
    console.log(arrTotal);
    
    var formas = arrForm.split(',');
    var totales = arrTotal.split(',');
    
    console.log(this.recibo);
    console.log(this.recibo.folioRec);
    //var auxRec = JSON.parse(this.recibo);

    var arrSpecialStrings = [{
      'TITULO': ">> CSI <<",
      'RFC': this.dataService.sRFC,
      'CP': this.dataService.sCP,
      'DIR1': this.dataService.sDi,
      'DIR2': this.dataService.sDi2,
      'TEL': this.dataService.sT1,
      'FOLIO': this.recibo.folioRec ? this.recibo.folioRec : (folio != folioFin ? folio + " al " + folioFin : folio),
      //'FOLIO': folio != folioFin ? folio + " al " + folioFin : folio,
      'FECHAEMI': this.fecEmi + " " + this.horaEmi,
      'AREA': this.dataService.findItemInObject(this.origenes, this.idOrigen, "id").origen.toUpperCase(),
      'CATEG': this.dataService.findItemInObject(this.origenes, this.idOrigen, "id").origen + "   [" + this.fecEmi + "]",
      'FORMA': formas.filter(this.dataService.onlyUnique),
      'LINEA1': "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[0].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[0]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[0],2), 12, "ANTES"),
      'LINEA2': this.numConceptos > 1 ? "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[1].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[1]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[1],2), 12, "ANTES") : "",
      'LINEA3': this.numConceptos > 2 ? "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[2].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[2]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[2],2), 12, "ANTES") : "",
      'LINEA4': this.numConceptos > 3 ? "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[3].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[3]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[3],2), 12, "ANTES") : "",
      'LINEA5': this.numConceptos > 4 ? "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[4].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[4]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[4],2), 12, "ANTES") : "",
      'LINEA6': this.numConceptos > 5 ? "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[5].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[5]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[5],2), 12, "ANTES") : "",
      'LINEA7': this.numConceptos > 6 ? "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[6].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[6]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[6],2), 12, "ANTES") : "",
      'LINEA8': this.numConceptos > 7 ? "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[7].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[7]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[7],2), 12, "ANTES") : "",
      'LINEA9': this.numConceptos > 8 ? "I" + this.idOrigen.toString().substring(this.idOrigen.toString().length - 1) + "   " + this.dataService.fnLlenaEspacios(formas[8].toUpperCase(), 55, "DESPUES") + "   " + this.dataService.fnLlenaEspacios("1", 4, "ANTES") + "        " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[8]), 12, "ANTES") + "  " + this.dataService.fnLlenaEspacios("$ " + this.dataService.fnFormatMoney(totales[8],2), 12, "ANTES") : "",
      'LINEAA': "",
      'LINEAB': "",
      'LINEAC': "",
      'LINEAD': "",
      'LINEAE': "",
      'TOTAL': "$ " + this.dataService.fnFormatMoney(this.total,2),
      'NUMASI_LETRA': this.dataService.fnLeeMonto(this.total)
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    image: "logoBlack.png",  
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }          
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    this.dd = {
      pageSize: this.formato[index].pageSize,
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }

    this.fnLimpia();

    if(this.abrirDescargarPDF==1){
      //console.log("open");
      pdfMake.createPdf(this.dd).open();
    }
    else{
      //console.log("print");
      pdfMake.createPdf(this.dd).print();
    }
  }



  fnConsolida(item){
    setTimeout(() => {
      if(item.checked){
        this.consolidaImp=true;
      }
      else{
        this.consolidaImp=false;
      }
    }, 50); 
  }


  fnCorte(){
    console.log("corte");
    var aux;
    aux = this.dataService.fnGetDateFormat(this.dataService.fnGetHoy(), 'D/M/Y');
    if(this.esFechaEspecial)
      aux = this.fechaEspecial;
    this.dataService.getCorte(aux).subscribe(
                                rows => {   
                                        this.corte = <any>rows
                                        },          
                                error => this.errMsg = <any>error,
                                () => this.fnCorteCargado());
  }

  fnCorteCargado(){
    console.log(this.corte);
    setTimeout(() => {
      this.corte = "";
    }, 3000);
  }s
}
